<div>
  <app-top-menu></app-top-menu>
  <div class="container-fluid">
    <router-outlet></router-outlet>
  </div>
</div>
